import React, { FC, useEffect, useRef, useState } from 'react'
import styles from './SEOContent.module.scss'
import SeoContentConnector, {
  ConnectorProps as SeoConnectorProps,
} from '../../connectors/SeoContent'
import classNames from 'classnames'
import {
  getBlurbLength,
  getNonTopNavBlurb,
  getPaintingsSEOBlurb,
  getPhotographySEOBlurb,
  getSculptureSEOBlurb,
} from './helpers'

type SEOBlurb = SeoConnectorProps

const SEOBlurb: FC<SEOBlurb> = (props) => {
  const { metadata, urlPath } = props
  const [isBlurbOpen, setIsBlurbOpen] = useState(false)
  const [shouldShowReadMoreOrLess, setShouldShowReadMoreOrLess] = useState(false)
  const paragraphRef = useRef<HTMLParagraphElement>(null)

  const handleReadMoreOrLess = () => {
    setIsBlurbOpen((oldValue) => !oldValue)
  }

  const [urlPathWithoutQuery] = urlPath.split('?')
  const blurbArray =
    getPaintingsSEOBlurb({ urlPath: urlPathWithoutQuery }) ||
    getPhotographySEOBlurb({ urlPath: urlPathWithoutQuery }) ||
    getSculptureSEOBlurb({ urlPath: urlPathWithoutQuery }) ||
    getNonTopNavBlurb(props)
  const blurbLength = getBlurbLength(blurbArray)
  const shouldSplitTwoColumns = blurbLength > 1000

  // Function to check if the text is too long to truncate and show READ MORE
  const checkTextLinesToTruncate = () => {
    const isHigher =
      paragraphRef.current && paragraphRef.current.scrollHeight > paragraphRef.current.clientHeight
    const isWider =
      paragraphRef.current && paragraphRef.current.scrollWidth > paragraphRef.current.clientWidth
    if (isHigher || isWider || isBlurbOpen) {
      setShouldShowReadMoreOrLess(true)
    } else {
      setShouldShowReadMoreOrLess(false)
    }
  }

  useEffect(() => {
    checkTextLinesToTruncate()

    const handleResize = () => {
      checkTextLinesToTruncate()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [isBlurbOpen])

  useEffect(() => {
    setIsBlurbOpen(false)
    checkTextLinesToTruncate()
  }, [metadata])

  if (blurbArray.length === 0) {
    return null
  }

  return (
    <div className={classNames(styles.blurbContainer, styles.grid)}>
      <div
        className={classNames(styles.blurbGrid, {
          [styles.blurbGridOneColumn]: !shouldSplitTwoColumns,
        })}
      >
        <p
          ref={paragraphRef}
          className={classNames(styles.blurbContentWrapper, {
            [styles.blurbContentWrapperOpen]: shouldSplitTwoColumns,
            [styles.blurbContentWrapperFull]: isBlurbOpen,
            [styles.truncatedMultiline]: !isBlurbOpen,
          })}
        >
          {blurbArray.map(({ title, content }) => (
            <>
              <h5>{title}</h5>
              <p dangerouslySetInnerHTML={{ __html: content }} />
            </>
          ))}
        </p>

        {shouldShowReadMoreOrLess && (
          <div className={styles.buttonColumnContainer}>
            <button onClick={handleReadMoreOrLess}>
              {isBlurbOpen ? 'READ LESS' : 'READ MORE'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default SeoContentConnector(SEOBlurb)
